import gql from 'graphql-tag'

export const DRIVER_LIST = gql`
  query Drivers {
    drivers {
      id
      name
      email
      emoji
      phoneNumber
      # status
    }
  }
`
